import Mask, { Direction, Selection, ValueWithSelection } from './Mask';

const EMPTY_VALUE: ValueWithSelection = { value: '', selection: { start: 0, end: 0 } };

const maskValue = (value: string, mask: Mask) => value.split('').reduce(mask.input.bind(mask), { ...EMPTY_VALUE });

const unmaskValue = (valueWithSelection: ValueWithSelection, mask: Mask) => mask.unmask(valueWithSelection);

const input = (valueWithSelection: ValueWithSelection, mask: Mask, char: string) =>
    mask.input(valueWithSelection, char);

const conformsToMask = (value: string, mask: Mask) => mask.conforms(value);

const remove = (valueWithSelection: ValueWithSelection, mask: Mask, direction: Direction = Direction.Backward) => {
    if (valueWithSelection.selection.start === valueWithSelection.selection.end) {
        return valueWithSelection;
    }

    return mask.remove(valueWithSelection, direction);
};

const select = (value: string, selection: Selection) => {
    const { length } = value;
    let { start, end } = selection;

    start = clamp(0, length, start);
    end = clamp(0, length, end);

    if (start > end) {
        const tmp = start;
        start = end;
        end = tmp;
    }

    return { value, selection: { start, end } };
};

const getValueWithPlaceholder = (valueWithSelection: ValueWithSelection, mask: Mask): string =>
    mask.getValueWithPlaceholder(valueWithSelection);

const clamp = (min: number, max: number, value: number) => Math.max(min, Math.min(value, max));

export default { maskValue, unmaskValue, input, conformsToMask, remove, select, getValueWithPlaceholder };
